import $ from 'jquery';

$(() =>
{
    var showTimeout = 0;

    for (let cartLinkElement of $('.cart-link'))
    {
        $(cartLinkElement).on('click', () =>
        {
            var cartVisible = $('body').hasClass('show-cart');

            setTimeout(() =>
            {
                if (cartVisible)
                    $('body').removeClass('show-cart');
                else
                {
                    $('body').addClass('show-cart');

                    clearTimeout(showTimeout);
                }
            });
        });
    }

    $('main').on('click', () =>
    {
        $('body').removeClass('show-cart');
    });

    var ignoreMutations = $('.widget_shopping_cart_content').children().length == 0 ? 1 : 0;

    if ($('.single-product .woocommerce-message .button.wc-forward').length > 0)
        ignoreMutations--;

    var observer = new MutationObserver(() =>
    {
        if (ignoreMutations-- <= 0)
        {
            if (!$('body').hasClass('show-cart'))
            {
                $('body').addClass('show-cart');
    
                // showTimeout = setTimeout(() =>
                // {
                //     $('body').removeClass('show-cart');
                // }, 5000);
            }
        }
    })

    observer.observe($('aside.cart')[0],
    {
        childList: true,
        subtree: true
    });

});